/**
 * Guía: Pagos a Creadores.
 *
 * Contenido derivado del capítulo **27** del manual: §0 (el mismo mecanismo
 * que las liquidaciones de comercio, con el matiz de que la comisión la paga
 * el comercio y la plataforma sólo la traslada) y del flujo F6.
 */

import type { TourFlow } from '../types';

const PAGOS_CREADOR_PATH = '/finance-influencer-payouts';

export const c27PagosACreadores: TourFlow = {
  id: 'admin.finance-influencer-payouts',
  chapter: '27',
  title: 'Pagos a creadores',
  summary:
    'El segundo tramo de un dinero que pone el comercio: cómo se liquida y qué lo bloquea.',
  href: PAGOS_CREADOR_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Mismo mecanismo que las liquidaciones de comercio',
      body:
        'Se generan a partir de sus comisiones no pagadas, se agrupan en lotes y se marcan ' +
        'como transferidas. Si conoces Liquidaciones a Comercios, esto es lo mismo con otro ' +
        'destinatario.',
      route: PAGOS_CREADOR_PATH,
    },
    {
      id: 'money-comes-from-the-store',
      title: 'Este dinero lo pone el comercio',
      body:
        'La comisión del creador se descuenta de la liquidación del comercio, y la ' +
        'plataforma sólo la traslada. Por eso no es un gasto de 121Pass sino un pasivo: ' +
        'dinero de otro que hay que entregar.',
      target: 'admin.influencerPayouts.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'only-active-earns',
      title: 'Un creador suspendido no entra en la generación',
      body:
        'No devenga mientras lo esté, y queda fuera de las corridas. Lo anterior no se ' +
        'pierde: entra en la primera liquidación después de reactivarlo.',
    },
    {
      id: 'bank-account',
      title: 'Sin cuenta principal aprobada no se transfiere',
      body:
        'Y es la causa más común de que un creador quede fuera de una corrida. La cuenta la ' +
        'registra él y la aprueba el equipo: una aprobada que no sea la principal no sirve.',
    },
  ],
};
